enum ColorDisablerButtonsEvents {
  /**
   * Dispatched when the pointer moves over any color disabled button.
   * `buttons`: `ColorDisablerButtons`. The disabled buttons object that dispatched the event.
   */
  DISABLER_BUTTON_OVER = 'disablerButtonOver',

  /**
   * Dispatched when the main color disabled button is pressed.
   * `buttons`: `ColorDisablerButtons`. The disabled buttons object that dispatched the event.
   */
  MAIN = 'main',

  /**
   * Dispatched when the second color disabled button is pressed.
   * `buttons`: `ColorDisablerButtons`. The disabled buttons object that dispatched the event.
   */
  SECOND = 'second',

  /**
   * Dispatched when the third color disabled button is pressed.
   * `buttons`: `ColorDisablerButtons`. The disabled buttons object that dispatched the event.
   */
  THIRD = 'third',
}

export default ColorDisablerButtonsEvents;
